import { Tabs } from "antd"
import { Projections } from "./Projections"
import { Assumptions } from "./Assumptions"
import { Liquidity } from "./Liquidity"
import { Reports } from "./Reports"

export const PrivateInvestments = () => {
  const items = [
    {
      key: "assumptions",
      label: "Assumptions",
      children: <Assumptions />,
    },
    {
      key: "projections",
      label: "Projections",
      children: <Projections />,
    },
    {
      key: "liquidity",
      label: "Liquidity",
      children: <Liquidity />,
    },
    {
      key: "reports",
      label: "Reports",
      children: <Reports />,
    },
  ]

  return <Tabs defaultActiveKey="assumptions" items={items} style={{ minWidth: "99vw", padding: 0 }} />
}
